enum NoiseType {
  White,
  Pink,
  Brown
}

export default NoiseType;
